import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

export const tableContainerSx: SxProps<Theme> = {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
};

export const addButtonSx: SxProps<Theme> = {
        // The whole footer, not a button sitting in it: the row is the affordance, so it spans the
        // card edge to edge under the last table row.
        width: '100%',
    padding: theme.spacing(10 / 8, 16 / 8),
    backgroundColor: theme.palette.background.default,
    borderTop: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    '&:hover': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:active': {
        backgroundColor: theme.palette.action.selected,
    },
};